import React, { useEffect, useRef, useState } from "react";
import { useAuth } from "../auth/FirebaseAuth.js";
import { useNavigate, useParams } from "react-router-dom";
import { getUserById } from "../models/UserFunctions.js";
import Row from "../layout/Row.js";
import Column from "../layout/Column.js";
import Divider from "../layout/Divider.js";
import Space from "../layout/Space.js";
import MLTFGPT2 from "../textfields/MLTFGPT2.js";
import DropDown1 from "../dropdowns/DropDown1.js";
import PrimaryButton from "../buttons/PrimaryButton.js";
import { useSnackbar } from "notistack";
import { getFirestore, Timestamp } from "firebase/firestore";
import { addDays } from "date-fns";
import { getDocument } from "pdfjs-dist";
// Example object where you want to set the timestamp

import {
  createDoc,
  getArrayDocDataByRef,
  queryCollection,
  getDocDataByRef,
  getDocDataById,
  updateDocDataField,
  getFlutterTime,
  getArrayDocDataByID,
} from "../models/DataFunctions.js";
import SecondaryButton from "../buttons/SecondaryButton.js";
import { set } from "date-fns";
import createNewDevis from "../api/create/createNewDevis.js";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken.js";
import { format } from "date-fns";
import { Skeleton } from "@mui/material";
import SmallSpinner from "../loading/SmallSpinner.js";
import { useAppContext } from "../config/AppContext.js";
import sendDV1 from "../api/sign/sendDV1.js";
import getTemporaryUrl from "../api/getTemporaryUrl.js";
import { InputNumber, Spin } from "antd";
import Icon1 from "../icons/Icon.js";
import Modal1 from "../modals/Modal1.js";
import uploadDropZoneTemporary from "../api/upload/uploadDropZoneTemporary.js";
import Dropzone1 from "../dropzones/DropZone1.js";
import transferInvoiceFiles from "../api/folder/transferInvoiceFiles.js";
import FillFormModal from "../modals/FillFormModal.js";
import WarningButton from "../buttons/WarningButton.js";
import DropDownGPT1 from "../dropdowns/DropDownGPT1.js";
import DropDownGPT0 from "../dropdowns/DropDownGTP0.js";
import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi.js";
import createDocApi from "../api/database/createDocApi.js";
import TextField2 from "../textfields/TextField2.js";
import TimelineNewInvoice from "../folder_modals/TimelineNewInvoice.js";
import Dropzone2 from "../dropzones/DropZone2.js";
import sendFormDevis from "../api/send/sendFormDevis.js";
import NewInvoiceForm from "./NewInvoiceForm.js";
import DropDownGPTS3 from "../dropdowns/DropDownGPTS3.js";
import TextField2T from "../textfields/TextField2T.js";
import DropDownGPT03 from "../dropdowns/DropDownGTP03.js";
import RecaptchaComponent from "../embed/RecaptchaComponent.js";
import PDF from "../pdf/PDF.js";
import { limitStringSize } from "./Invoice.js";
import updateDocApi from "../api/database/updateDocApi.js";
import {
  audit_mpr_options,
  audit_profil_options,
} from "./folder_pages/NewFolder.js";
import MLTFGPT3 from "../textfields/MLTFGPT3.js";
import { hasAudit } from "../hexagone/VisibilityHelpers.js";
import DropDownGPT0X from "../dropdowns/DropDownGTP0X.js";
import CurrencyField from "../textfields/CurrencyField.js";
import MLTFGPT1 from "../textfields/MLTFGPT1.js";
import { checkAndSendTriggerEvent } from "../config/TriggerEmailSystem.js";

function NewInvoiceFromDraft({
  userData,
  orgData,
  navigateWorkspace,
  workspaceData,
  iframe = false,
}) {
  const { id } = useParams(); // Access the `id` parameter from the URL
  const [invoiceData, setInvoiceData] = useState(null);
  let mobile = iframe?.deviceWidth < 768;
  const { currentUser, loading } = useAuth();
  const [client_selected = null, setClientSelected] = useState(null);
  const [client, setClient] = useState(null);
  const [workspace, setWorkspace] = useState(null);
  const [master, setMaster] = useState(null);
  const [needed_files, setNeededFiles] = useState([]);
  const [clients_name_options, setClients_options] = useState([]);
  const [clients, setClients] = useState([]);
  const [article_configuration, setArticle_configuration] = useState({
    step: 0,
    units: 1,
    surfaces: [],
  });
  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };
  const [display_final, setDisplayFinal] = useState(false);
  // State variables to store the input values
  const [adresse_projet, setAdresse_projet] = useState("");
  const [code_postal_projet, setCode_postal_projet] = useState("");
  const [ville_projet, setVille_projet] = useState("");
  const [adresse_maitre_ouvrage, setAdresse_maitre_ouvrage] = useState("");
  const [code_postal_maitre_ouvrage, setCode_postal_maitre_ouvrage] =
    useState("");
  const [ville_maitre_ouvrage, setVille_maitre_ouvrage] = useState("");
  const [nom_maitre_ouvrage, setNom_maitre_ouvrage] = useState("");
  const [civilite_maitre_ouvrage, setCivilite_maitre_ouvrage] = useState("M.");
  const [first_name_maitre_ouvrage, setFirst_name_maitre_ouvrage] =
    useState("");
  const [email_maitre_ouvrage, setEmail_maitre_ouvrage] = useState("");
  const [telephone_maitre_ouvrage, setTelephone_maitre_ouvrage] = useState("");
  const [all_articles, setAll_articles] = useState([]);

  const [selected_articles, setSelected_articles] = useState([]);

  const [surface, setSurface] = useState(0);
  const [surfaces, setSurfaces] = useState([0]);
  const [nombre_maisons, setNombre_maisons] = useState(1);

  const [loadingData, setLoadingData] = useState(false);
  const [errorMissingInfosDevis, setErrorMissingInfosDevis] = useState(false);
  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  const [tranches_surface, setTranches_surface] = useState([]);
  const [tranches_maison, setTranches_maison] = useState([]);

  const [dropped_files, setDroppedFiles] = useState([]);
  const [loading_drop = false, setLoadingDrop] = useState(false);
  const [dropped_exists, setDroppedExists] = useState(false);

  const [marque, setMarque] = useState(null);
  const [marques_options, setMarques_options] = useState([]);
  const [available_forms, setAvailable_forms] = useState([]);
  const [forms, setForms] = useState([]);
  const [formOpen, setFormOpen] = useState(false);
  const [forms_filled, setFormsFilled] = useState([]);

  const [type_client, setTypeClient] = useState(iframe ? "particulier" : null);
  const [audit_config, setAuditConfig] = useState({});
  const [comments, setComments] = useState("");
  const [step, setStep] = useState(0);
  const [complementary_infos, setComplementaryInfos] = useState("");
  const [showModifyWarning, setShowModifyWarning] = useState(false);
  const [isModifying, setIsModifying] = useState(false);

  useEffect(() => {
    checkAnyFormAvailable();
  }, [selected_articles]);

  function checkArticleRemiseMaison(article) {
    let desc_remise_maisons = (
      (article && article.remise?.maison_tranches) ||
      []
    ).sort((a, b) => b.maison - a.maison);
    if (article && article.remise?.maison_tranches) {
      for (let i = 0; i < desc_remise_maisons.length; i++) {
        if (article.quantity >= desc_remise_maisons[i].maison) {
          return desc_remise_maisons[i].remise;
        }
      }
    }
    return 0;
  }

  function checkArticleSupplementSurface(article) {
    if (!article?.remise?.surface_tranches || surfaces.length === 0) return 0;
    let total = 0;
    for (const s of surfaces) {
      for (const tranche of article.remise.surface_tranches) {
        if (s > tranche.surface && s <= tranche.surface_max) {
          total += tranche.supplement;
          break;
        }
      }
    }
    return total;
  }

  function getDiscountValue(article) {
    if (article && article.discount) {
      if (article.discount?.type === "percent") {
        const totalBeforeDiscount =
          article.price * article.quantity +
          (article.supplement_total || 0);
        return (totalBeforeDiscount * article.discount.value) / 100;
      } else {
        return article.discount.value || 0;
      }
    }
    return 0;
  }

  function getTotals() {
    const base_ht = selected_articles.reduce(
      (acc, a) => acc + a.price * a.quantity,
      0
    );
    const supplement =
      selected_articles.reduce(
        (acc, a) => acc + (a.supplement_total || 0),
        0
      ) + handleSurfaceTranches();

    const total_remise = selected_articles.reduce(
      (acc, a) => acc + getDiscountValue(a),
      0
    );

    const total_ht = base_ht + supplement - total_remise;
    const total_ttc = total_ht * 1.2;
    const tva = total_ht * 0.2;
    return { base_ht, tva, total_ht, supplement, total_remise, total_ttc };
  }
  const onDelete = (file) => {
    const new_files = dropped_files.filter((f) => f !== file);
    setDroppedFiles(new_files);
    if (new_files.length === 0) {
      setDroppedExists(false);
    }
  };

  const removeArticle = (article) => {
    const new_articles = selected_articles.filter(
      (a) => a && a?.name !== article?.name
    );
    setSelected_articles(new_articles);
    checkAnyFormAvailable();
  };

  const checkAnyFormAvailable = () => {
    // for each form look at articles selected and if article.form_ref, then add form to available_forms
    const available_forms = [];

    for (let form of forms) {
      let form_available = false;
      for (let article of selected_articles) {
        if (article && article?.form_ref && article?.form_ref.id === form.id) {
          form_available = true;
          break;
        }
      }
      if (form_available) {
        available_forms.push(form);
      }
    }
    setAvailable_forms(available_forms);
  };

  const force_articles_updated = useRef(false);

  useEffect(() => {
    if (force_articles_updated.current) {
      handleRefreshArticles();
      force_articles_updated.current = false;
    }
  }, [force_articles_updated?.current]);

  useEffect(() => {
    if (selected_articles.length > 0) {
      handleRefreshArticles();
    }
  }, [surface, nombre_maisons]);

  useEffect(() => {
    const count = nombre_maisons || 1;
    setSurfaces((prev) => {
      if (prev.length === count) return prev;
      if (prev.length < count) {
        return [...prev, ...Array(count - prev.length).fill(0)];
      }
      return prev.slice(0, count);
    });
  }, [nombre_maisons]);

  const handleRefreshArticles = async () => {
    // calculate total price of selected articles
    let new_selected_articles = [];
    for (let article of selected_articles) {
      let remise = checkArticleRemiseMaison(article);
      if (article.discount == null) {
        if (remise > 0) {
          article.discount = {
            type: "percent",
            value: remise,
          };
        } else {
          article.discount = null;
        }
      }

      // Calculate the supplement for this article based on per-house surfaces
      article.supplement_total = checkArticleSupplementSurface(article);

      article.total_ht =
        article.price * article.quantity +
        article.supplement_total;
      article.total_ht_rem = article.total_ht - getDiscountValue(article);
      article.total_ttc = article.total_ht_rem * (1 + article.tax / 100);

      new_selected_articles.push(article);
    }
    setSelected_articles(new_selected_articles);
  };

  const formFilled = (form) => {
    const forms = [...forms_filled];
    forms.push(form);
    setFormsFilled(forms);
  };

  const handleSetClient = async (value) => {
    if (value === null) {
      setClientSelected(null);
      setClient(null);
      setSelected_articles([]);
      return;
    }
    let client_value = value;
    const client = clients.find((client) => client.id === client_value);
    let workspaces = await getArrayDocDataByID(
      "workspace",
      client.workspaces_id
    );
    let workspace = workspaces.find((w) => w.master_id === orgData.id);
    setWorkspace(workspace);
    setClientSelected(value);
    setClient(client);
    setSelected_articles([]);

    if (client.marques) {
      const marques_options = client.marques.map((marque) => {
        return { value: marque?.name, label: marque?.name };
      });
      setMarques_options(marques_options);
      setMarque(marques_options[0]);
    }
  };
  const [pdf_open, setPDFOpen] = useState(null);

  const handleViewFile = async (file) => {
    const token = await getOrRefreshFirebaseToken();
    await getTemporaryUrl(token, "devis", "", invoiceData.id, prefix);
    const new_invoice = await getDocDataById("devis", id);
    setInvoiceData(new_invoice);
    let plans_files = new_invoice.plans_files;
    let matching_file = plans_files.find((f) => f.name === file.name);
    matching_file.url
      ? setPDFOpen([matching_file])
      : handleClickVariant("Le fichier n'est pas disponible", "error");
  };

  const transferFiles = async (invoiceid, files = null) => {
    try {
      const token = await getOrRefreshFirebaseToken();
      const filesToTransfer = files !== null ? files : dropped_files;
      await transferInvoiceFiles(invoiceid, filesToTransfer, token, prefix);

      setDroppedFiles([]);
      setDroppedExists(false);
    } catch (error) {
      console.error("Error transfering files:", error);
    }
  };

  function getArticlePrice(article) {
    if (!article) return 0;
    if (type_client === "particulier") return parseInt(article.base_price);
    const negoces = workspace.negoces || [];
    const negoce = negoces.find((negoce) => negoce.article_id === article?.id);
    if (negoce) {
      if (typeof negoce.price_ht === "string") {
        let amount = negoce.price_ht.replace(",", ".");
        return parseFloat(amount);
      } else {
        return negoce.price_ht;
      }
    } else {
      const base_price_int = parseInt(article.base_price);
      return base_price_int;
    }
  }

  // Fetch user, org, clients, and article data
  const handleFetchData = async () => {
    if (!iframe && currentUser) {
      try {
        // Fetch user data

        let invoice = await getDocDataById("devis", id);
        setArticle_configuration(invoice.article_configuration || {});
        setInvoiceData(invoice);
        setTypeClient(invoice.client_id ? "pro" : "particulier");
        setMarque(invoice.marque);
        setNom_maitre_ouvrage(invoice.nom);
        setCivilite_maitre_ouvrage(invoice.civilite_client || "M.");
        setFirst_name_maitre_ouvrage(invoice.first_name || "");
        setAdresse_maitre_ouvrage(invoice.adresse_client);
        setCode_postal_maitre_ouvrage(invoice.postal_client);
        setVille_maitre_ouvrage(invoice.ville_client);
        setEmail_maitre_ouvrage(invoice.email_client);
        setTelephone_maitre_ouvrage(invoice.tel_client);
        setAdresse_projet(invoice.adresse_projet);
        setCode_postal_projet(invoice.postal_projet);
        setVille_projet(invoice.ville_projet);
        setSurface(invoice.surface);
        const isHouseType = (invoice.article_configuration?.type || invoice.structure_type) === "house"
          || invoice.structure_type === "maison_individuelle";
        const savedSurfaces = invoice.surfaces
          || invoice.article_configuration?.surfaces
          || null;
        if (isHouseType && savedSurfaces && Array.isArray(savedSurfaces) && savedSurfaces.length > 0) {
          const parsed = savedSurfaces.map((s) => parseFloat(s) || 0);
          setSurfaces(parsed);
          setNombre_maisons(parsed.length);
        } else if (invoice.surface) {
          const surfaceVal = parseFloat(invoice.surface) || 0;
          const count = isHouseType ? (invoice.nombre_maisons || 1) : 1;
          setSurfaces(isHouseType && count > 1 ? Array(count).fill(0) : [surfaceVal]);
          setNombre_maisons(count);
        } else {
          setNombre_maisons(invoice.nombre_maisons || 1);
        }
        setAuditConfig(invoice.audit_config || {});
        setComments(invoice.comments || "");
        setComplementaryInfos(invoice.complementary_infos || "");
        setSelected_articles(invoice.articles || []);

        // Check if this is a modification (not a draft)
        if (invoice.state !== "draft") {
          setIsModifying(true);
        }

        let master = null;
        let client = null;
        let client_selected = null;
        if (!workspaceData) {
          master = orgData;
        }
        setMaster(master);
        const filtersclient = [
          {
            field: "masters_id",
            operator: "array-contains",
            value: master.id,
          },
        ];

        const clients = await queryCollection("org", filtersclient);
        setClientSelected(invoice.client_id);
        client = clients.find((c) => c.id === invoice.client_id);
        if (client) {
          setClient(client);
          let workspaces = await getArrayDocDataByID(
            "workspace",
            client.workspaces_id
          );
          let workspace = workspaces.find((w) => w.master_id === orgData.id);
          setWorkspace(workspace);
        }

        const clients_name = clients.map((client) => {
          return { value: client.id, label: client?.name };
        });
        const sorted_clients_names = clients_name.sort((a, b) =>
          a.label.localeCompare(b.label)
        );
        setClients_options(sorted_clients_names);
        setClients(clients);

        const filters = [
          {
            field: "org_id",
            operator: "==",
            value: master.id,
          },
        ];

        let tranches_surface = orgData.infos?.remise?.surface_tranches || [];
        let tranches_maison = orgData.infos?.remise?.maison_tranches || [];
        setTranches_surface(tranches_surface);
        setTranches_maison(tranches_maison);

        const all_articles = await queryCollection("article", filters);
        const sorted_all_articles = all_articles.sort((a, b) =>
          a?.name.localeCompare(b?.name)
        );
        setAll_articles(sorted_all_articles);

        const forms = await queryCollection("form", filters);
        setForms(forms);

        // Update state with fetched data
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };

  const handleCheckToStep = (step) => {
    if (step === 1) {
      if (article_configuration.type === "house" && surfaces.some((s) => !s || s === 0)) {
        handleClickVariant("Veuillez saisir la surface de chaque maison", "error");
        return;
      }
      if (nombre_maisons === 0 && article_configuration.type === "house") {
        handleClickVariant("Veuillez saisir le nombre de maisons", "error");
        return;
      }
      if (selected_articles.length === 0) {
        handleClickVariant(
          "Veuillez sélectionner au moins un article",
          "error"
        );
        return;
      }

      let needed_files = [];
      for (let article of selected_articles) {
        if (article?.needed_files) {
          let files = article?.needed_files || [];
          for (let i = 0; i < files.length; i++) {
            let file = files[i];
            if (!needed_files.map((f) => f.name).includes(file.name)) {
              needed_files.push(file);
            }
          }
        }
      }
      setNeededFiles(needed_files);

      setStep(step + 1);
    }
    if (step === 2) {
      if (!type_client) {
        handleClickVariant("Veuillez sélectionner un type de client", "error");
        return;
      }
      if (!client && type_client === "pro") {
        handleClickVariant("Veuillez sélectionner un client", "error");
        return;
      }
      if (!adresse_projet) {
        handleClickVariant("Veuillez saisir l'adresse du projet", "error");
        return;
      }
      if (!code_postal_projet) {
        handleClickVariant("Veuillez saisir le code postal du projet", "error");
        return;
      }
      if (!ville_projet) {
        handleClickVariant("Veuillez saisir la ville du projet", "error");
        return;
      }
      if (!adresse_maitre_ouvrage) {
        handleClickVariant(
          "Veuillez saisir l'adresse du maître d'ouvrage",
          "error"
        );
        return;
      }
      if (!code_postal_maitre_ouvrage) {
        handleClickVariant(
          "Veuillez saisir le code postal du maître d'ouvrage",
          "error"
        );
        return;
      }
      if (!ville_maitre_ouvrage) {
        handleClickVariant(
          "Veuillez saisir la ville du maître d'ouvrage",
          "error"
        );
        return;
      }
      if (!nom_maitre_ouvrage) {
        handleClickVariant(
          "Veuillez saisir le nom du maître d'ouvrage",
          "error"
        );
        return;
      }
      if (!email_maitre_ouvrage) {
        handleClickVariant(
          "Veuillez saisir l'email du maître d'ouvrage",
          "error"
        );
        return;
      }
      // check if email is valid
      if (!email_maitre_ouvrage.trim().match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
        handleClickVariant(
          "Veuillez saisir une adresse email valide.",
          "error"
        );
        return;
      }
      if (!telephone_maitre_ouvrage) {
        handleClickVariant(
          "Veuillez saisir le téléphone du maître d'ouvrage",
          "error"
        );
        return;
      }

      setStep(step + 1);
    }

    if (step === 3) {
      setStep(step + 1);
      createInvoice();
    }
  };

  const createInvoice = async (skipWarning = false) => {
    try {
      // Show warning if modifying a sent or signed invoice
      if (
        isModifying &&
        !skipWarning &&
        (invoiceData.state === "wait" || invoiceData.state === "done")
      ) {
        setShowModifyWarning(true);
        return;
      }

      if (orgData.config?.devis?.connected !== true) {
        handleClickVariant(
          "Vous devez renseigner toutes les informations de votre compte avant de créer un devis",
          "error"
        );
        setErrorMissingInfosDevis(true);
        return;
      }
      setLoadingData(true); // Set loading state to true

      // Determine the new state:
      // - If it was "wait" (sent), keep it as "wait" so client can still access it
      // - If it was "done" (signed), reset to "locked" because signature is invalid
      // - Otherwise, set to "locked" for new invoices
      const newState =
        isModifying && invoiceData.state === "wait" ? "wait" : "locked";

      const body = {
        org_id: master.id,
        client_id: type_client === "pro" ? client.id : null,
        state: newState,
        champs: [], // Clear signature fields
        presign_file: null, // Clear presign file
        sign_date: null, // Clear sign date
        nom: nom_maitre_ouvrage,
        first_name: first_name_maitre_ouvrage,
        logo_url:
          master.logo ||
          "https://i.ibb.co/CWHxrfX/Hexagone-UXLogo3-LOW-1024.png",
        forms: forms_filled || [],
        master_name: master?.name,
        master_adresse: master.infos.adresse,
        master_postal: master.infos.postal,
        master_ville: master.infos.ville,
        siret: master.infos.siret || "",
        num_tva: master.infos.num_tva || "",
        phone: master.infos.phone || "",
        email: master.infos.email || "",
        num_devis: isModifying
          ? invoiceData.num_devis
          : "DEV" + Math.floor(Math.random() * 1000000),
        date: format(new Date(), "dd/MM/yyyy"),
        num_cient: type_client === "pro" ? client.id : "particulier",
        date_validite: format(addDays(new Date(), 365), "dd/MM/yyyy"),
        nom_client: nom_maitre_ouvrage,
        civilite_client: civilite_maitre_ouvrage,
        adresse_client: adresse_maitre_ouvrage,
        postal_client: code_postal_maitre_ouvrage,
        ville_client: ville_maitre_ouvrage,
        adresse_projet: adresse_projet,
        postal_projet: code_postal_projet,
        ville_projet: ville_projet,
        banque: master.infos.banque || "",
        iban: master.infos.iban || "",
        bic: master.infos.bic || "",
        prix_tot_ttc: getTotals().total_ttc,
        politique_annulation: master.infos.politique_annulation || "",
        conditions_generales_vente:
          master.infos.conditions_generales_vente || "",
        conditions_reglement: master.infos.conditions_reglement,
        politique_echec: master.infos.politique_echec,
        complementary_infos: complementary_infos,
        email_client: email_maitre_ouvrage,
        tel_client: telephone_maitre_ouvrage,

        articles: selected_articles || [],
        surface: surfaces.reduce((a, b) => a + (b || 0), 0),
        surfaces: surfaces,
        nombre_maisons: surfaces.length,
        base_ht: getTotals().base_ht,
        supplement: getTotals().supplement,
        total_remise: getTotals().total_remise,
        total_ht: getTotals().total_ht,
        tva: getTotals().tva,
        total_ttc: getTotals().total_ttc,
        marque: type_client === "pro" ? marque : "Particulier",
        client_type: client?.client_type || "particulier",
        history_events: invoiceData?.history_events.concat([
          {
            date: Timestamp.now(),
            name: isModifying ? "Modification du devis" : "Génération du devis",
          },
        ]),
        author: invoiceData?.author || "master",
        structure_type:
          article_configuration.type === "house"
            ? "maison_individuelle"
            : "extension",
        audit_config: audit_config,
        comments: comments,
      };

      const new_devis = await updateDocApi(invoiceData.ref, body, prefix);
      let token = await getOrRefreshFirebaseToken();
      let author = iframe ? "website" : orgData?.type;
      const sign_field = await createNewDevis(new_devis, author, token, prefix);
      let devis_generated = await getDocDataById("devis", new_devis.id);
      await getTemporaryUrl(token, "devis", "", devis_generated.id, prefix);
      // wait for the url to be generated
      devis_generated = await getDocDataById("devis", new_devis.id);

      // Add the generated PDF to the files
      if (devis_generated.file?.url) {
        const pdfFile = {
          url: devis_generated.file.url,
          name: `Devis_${devis_generated.num_devis} (vierge).pdf`,
        };

        // Remove old vierge version if it exists
        let existing_files = devis_generated.plans_files || [];
        const filtered_files = existing_files.filter(
          (file) => !file.name?.includes("(vierge)")
        );

        // Update the plans_files to remove old vierge version
        if (existing_files.length !== filtered_files.length) {
          await updateDocDataFieldApi(
            devis_generated.ref,
            "plans_files",
            filtered_files,
            prefix
          );
        }

        const files_to_transfer = [pdfFile, ...dropped_files];
        await transferFiles(devis_generated.id, files_to_transfer);
      } else if (dropped_files.length > 0) {
        await transferFiles(devis_generated.id, dropped_files);
      }
      const champs = [
        {
          type: "Signature",
          label: "Signature",
          w: sign_field.w,
          h: sign_field.h,
          x: sign_field.x,
          y: sign_field.y,
        },
      ];

      await updateDocDataFieldApi(new_devis.ref, "champs", champs, prefix);
      const height = 841.8898;
      const width = 595.2756;
      //const { width, height } = await getPDFDimensions(
      //  devis_generated.file.url
      //);

      if (!devis_generated.file?.url) {
        handleClickVariant("Erreur lors de la création du devis", "error");
        setLoadingData(false); // Set loading state to false
        return;
      }

      await sendDV1(
        champs,
        devis_generated.file.url,
        token,
        devis_generated.id,
        prefix,
        height,
        width
      );

      if (devis_generated.forms && devis_generated.forms.length > 0) {
        let form_devis_dict = {
          infos_devis: {
            id: devis_generated.id,
            name: nom_maitre_ouvrage,
            email: email_maitre_ouvrage,
            phone: telephone_maitre_ouvrage,
            address: adresse_maitre_ouvrage,
            postal: code_postal_maitre_ouvrage,
            city: ville_maitre_ouvrage,
            country: "France",
          },
          infos_master: {
            name: master.name,
            email: master.infos.email,
            phone: master.infos.phone,
            date: format(new Date(), "dd/MM/yyyy HH:mm:ss"),
            logo: master.logo || "https://i.ibb.co/8Nc2tS4/Placeholder.png",
          },
          form_name: devis_generated.forms[0].name,
          categories: devis_generated.forms[0].cochamps.map((co) => {
            let new_champs = co.champs.map((ch) => {
              return {
                name: ch.name,
                type: ch.type === "case" ? "check" : "text",
                value: ch.content
                  ? ch.content
                  : ch.type === "case"
                    ? false
                    : "",
              };
            });
            return {
              name: co.name,
              fields: new_champs,
            };
          }),
        };

        token = await getOrRefreshFirebaseToken();
        await sendFormDevis(devis_generated.id, form_devis_dict, token, prefix);
      }

      handleClickVariant(
        isModifying ? "Devis modifié avec succès" : "Devis créé avec succès",
        "success"
      );
      if (iframe) {
        iframe.setSuccess(true);
      } else {
        navigateWorkspace("/invoice/" + new_devis.id);
      }

      setLoadingData(false); // Set loading state to false
    } catch (error) {
      console.error("Error creating invoice:", error);
      handleClickVariant("Erreur lors de la création du devis", "error");
      setLoadingData(false); // Set loading state to false
    }
  };

  function handleSurfaceTranches() {
    let total = 0;
    for (const s of surfaces) {
      for (const tranche of tranches_surface) {
        if (s > tranche.surface && s <= tranche.surface_max) {
          total += tranche.addition;
          break;
        }
      }
    }
    return total;
  }

  function getSurfaceTranchesBreakdown() {
    const breakdown = [];
    for (let i = 0; i < surfaces.length; i++) {
      let addition = 0;
      for (const tranche of tranches_surface) {
        if (surfaces[i] > tranche.surface && surfaces[i] <= tranche.surface_max) {
          addition = tranche.addition;
          break;
        }
      }
      breakdown.push({ index: i, surface: surfaces[i], addition });
    }
    return breakdown;
  }

  function getArticleSupplementBreakdown(article) {
    if (!article?.remise?.surface_tranches || surfaces.length === 0) return [];
    const breakdown = [];
    for (let i = 0; i < surfaces.length; i++) {
      let supplement = 0;
      for (const tranche of article.remise.surface_tranches) {
        if (surfaces[i] > tranche.surface && surfaces[i] <= tranche.surface_max) {
          supplement = tranche.supplement;
          break;
        }
      }
      breakdown.push({ index: i, surface: surfaces[i], supplement });
    }
    return breakdown;
  }

  const [openDescription, setOpenDescription] = useState(null);

  useEffect(() => {
    if (currentUser || iframe.master_id) {
      handleFetchData(); // Fetch user data when currentUser is available
    }
  }, [currentUser, iframe]); // Dependency array ensures this runs when currentUser changes

  // Function to create a new client
  // loading || !currentUser || !userData
  if (iframe ? false : loading || !currentUser || !userData) {
    return (
      <div className="w-full h-full overflow-auto flex flex-row">
        <SmallSpinner />{" "}
      </div>
    );
  }

  return (
    <div className={`h-full overflow-auto flex min-h-c400 w-full`}>
      {/* Left Column: Takes all available space */}
      <Modal1 isOpen={pdf_open} onClose={() => setPDFOpen(null)}>
        <div className="flex flex-col w-c900 h-fit bg-neutral-100 rounded-md">
          {" "}
          <PDF files={pdf_open} onClose={() => setPDFOpen(null)}></PDF>
        </div>
      </Modal1>
      <Modal1
        isOpen={errorMissingInfosDevis}
        onClose={() => setErrorMissingInfosDevis(null)}
      >
        <div className="flex flex-col text-h3 w-c300 h-fit  bg-white rounded-xl">
          <div className=" p-4  border-b-1 ">
            Erreur lors de la création du devis
          </div>{" "}
          <div className=" p-4 bg-neutral-50 ">
            Vous devez renseigner toutes les informations de votre compte avant
            de créer un devis.
          </div>
          <div className="flex flex-row justify-end w-full  border-t-1  p-4 ">
            <PrimaryButton
              className={"w-fit"}
              onClick={() => {
                navigateWorkspace("/devisparams");
              }}
            >
              Configurer
            </PrimaryButton>
          </div>
        </div>
      </Modal1>
      <Modal1
        isOpen={showModifyWarning}
        onClose={() => setShowModifyWarning(false)}
      >
        <div className="flex flex-col text-h3 w-c400 h-fit  bg-white rounded-xl">
          <div className=" p-4  border-b-1 font-semibold text-h2">
            ⚠️ Modification d'un devis{" "}
            {invoiceData?.state === "done" ? "signé" : "envoyé"}
          </div>{" "}
          <div className=" p-4 bg-neutral-50 ">
            {invoiceData?.state === "done" ? (
              <>
                <div className="mb-2 font-medium">
                  Ce devis a déjà été signé par le client.
                </div>
                <div className="mb-2">En modifiant ce devis :</div>
                <ul className="list-disc ml-5 mb-2">
                  <li>
                    L'ancienne version signée sera remplacée par la nouvelle
                    version
                  </li>
                  <li>La signature actuelle sera supprimée</li>
                  <li>
                    Vous devrez renvoyer le devis au client pour une nouvelle
                    signature
                  </li>
                </ul>
              </>
            ) : (
              <>
                <div className="mb-2 font-medium">
                  Ce devis a été envoyé au client mais n'a pas encore été signé.
                </div>
                <div className="mb-2">En modifiant ce devis :</div>
                <ul className="list-disc ml-5 mb-2">
                  <li>
                    Le client verra automatiquement la nouvelle version
                    lorsqu'il accédera au lien de signature
                  </li>
                  <li>L'ancienne version sera remplacée</li>
                  <li>
                    Le devis restera dans l'état "En attente" - pas besoin de le
                    renvoyer
                  </li>
                </ul>
              </>
            )}
            <div className="mt-3 font-medium">Voulez-vous continuer ?</div>
          </div>
          <div className="flex flex-row justify-end gap-2 w-full  border-t-1  p-4 ">
            <SecondaryButton
              className={"w-fit"}
              onClick={() => setShowModifyWarning(false)}
            >
              Annuler
            </SecondaryButton>
            <PrimaryButton
              className={"w-fit"}
              onClick={() => {
                setShowModifyWarning(false);
                createInvoice(true);
              }}
            >
              Confirmer la modification
            </PrimaryButton>
          </div>
        </div>
      </Modal1>
      <Modal1 isOpen={openDescription} onClose={() => setOpenDescription(null)}>
        <div className="flex flex-col p-4 bg-white rounded-xl max-w-c400">
          <div className="text-h1 font-semibold">{openDescription?.name}</div>
          <Space y={10} />
          <div className="text-h3 text-shadow_50">
            {openDescription?.description}
          </div>
          <Space y={10} />
          <div className="text-h3 text-shadow_50">
            {"Prix HT: " + formatToEuro(getArticlePrice(openDescription))}
          </div>
        </div>
      </Modal1>

      <Modal1 isOpen={formOpen} onClose={() => setFormOpen(null)}>
        <FillFormModal
          orgData={orgData}
          form_id={formOpen?.id}
          onClose={() => setFormOpen(null)}
          formFilled={formFilled}
          prefix={prefix}
          workspaceData={workspaceData}
        ></FillFormModal>
      </Modal1>

      {/* Right Column: Fixed width */}
      <div className="flex flex-col gap-1 h-fit px-4 w-full ">
        <div className={`text-hx font-semibold mb-6`}>
          {isModifying
            ? "Modifier le devis"
            : "Nouveau devis à partir d'un brouillon"}
        </div>
        <div className="flex flex-row gap-4 pb-10 pr-4 w-full h-fit">
          <div className="flex flex-col gap-2 w-full ">
            <div className="flex flex-col gap-2 max-w-c500 ">
              <MLTFGPT3
                label={"Commentaires et instructions pour le devis"}
                value={comments}
                rows={6}
                onChange={(e) => setComments(e.target.value)}
              ></MLTFGPT3>
              <div className="w-full flex flex-col justify-start ">
                <NewInvoiceForm
                  mobile={mobile}
                  setStep={setStep}
                  disabled={true}
                  article_configuration={article_configuration}
                  setArticle_configuration={setArticle_configuration}
                ></NewInvoiceForm>
              </div>
              <div className="flex flex-col gap-2 w-full">
                <DropDownGPT03
                  items={[
                    {
                      value: "pro",
                      label: "Client professionnel",
                    },
                    {
                      value: "particulier",
                      label: "Client particulier",
                    },
                  ]}
                  className="w-full"
                  label="Type de client"
                  value={type_client}
                  onChange={(e) => setTypeClient(e.value)} // Update state on change
                ></DropDownGPT03>

                {type_client === "pro" && (
                  <DropDownGPTS3
                    items={clients_name_options}
                    className="w-full"
                    label="Client"
                    value={client_selected} // Controlled component
                    onChange={(e) => handleSetClient(e.value)}
                  ></DropDownGPTS3>
                )}
              </div>
              {marques_options.length > 0 && (
                <>
                  <DropDownGPTS3
                    items={marques_options}
                    className="w-full"
                    label="Marque"
                    mandatory={true}
                    value={marque} // Controlled component
                    onChange={(e) => setMarque(e.value)} // Update state on change
                  ></DropDownGPTS3>
                </>
              )}

              <div className="w-full  flex flex-col gap-2">
                <TextField2T
                  className="w-full"
                  label="Adresse projet"
                  mandatory={true}
                  value={adresse_projet}
                  onChange={(e) => setAdresse_projet(e.target.value)}
                ></TextField2T>
                <div className="flex flex-row justify-between w-full gap-2">
                  <TextField2T
                    className="w-full"
                    label="Code postal"
                    mandatory={true}
                    value={code_postal_projet}
                    onChange={(e) => setCode_postal_projet(e.target.value)}
                  ></TextField2T>
                  <TextField2T
                    className="w-full"
                    label="Ville"
                    mandatory={true}
                    value={ville_projet}
                    onChange={(e) => setVille_projet(e.target.value)}
                  ></TextField2T>
                </div>
                <Space y={10} />
                <TextField2T
                  className="w-full"
                  label="Adresse maitre d'ouvrage"
                  mandatory={true}
                  value={adresse_maitre_ouvrage}
                  onChange={(e) => setAdresse_maitre_ouvrage(e.target.value)}
                  items={[
                    {
                      value: adresse_projet,
                      label: adresse_projet,
                    },
                  ]}
                  useSuggestedValue={() => {
                    setAdresse_maitre_ouvrage(adresse_projet);
                    setCode_postal_maitre_ouvrage(code_postal_projet);
                    setVille_maitre_ouvrage(ville_projet);
                  }}
                ></TextField2T>
                <div className="flex flex-row justify-between w-full gap-2">
                  <TextField2T
                    className="w-full"
                    label="Code postal"
                    mandatory={true}
                    value={code_postal_maitre_ouvrage}
                    onChange={(e) =>
                      setCode_postal_maitre_ouvrage(e.target.value)
                    }
                  ></TextField2T>
                  <TextField2T
                    className="w-full"
                    label="Ville"
                    mandatory={true}
                    value={ville_maitre_ouvrage}
                    onChange={(e) => setVille_maitre_ouvrage(e.target.value)}
                  ></TextField2T>
                </div>
                <Space y={10} />
                <DropDownGPT03
                  label="Civilité du maître d'ouvrage"
                  value={civilite_maitre_ouvrage}
                  mandatory={true}
                  onChange={(e) => {
                    setCivilite_maitre_ouvrage(e.value);
                  }}
                  items={[
                    { value: "M.", label: "M." },
                    { value: "Mme", label: "Mme" },
                    { value: "Mlle", label: "Mlle" },
                    { value: "M. et Mme", label: "M et Mme" },
                    { value: "Ignorer", label: "Ignorer" },
                  ]}
                ></DropDownGPT03>
                <TextField2T
                  label="Nom du maître d'ouvrage"
                  mandatory={true}
                  value={nom_maitre_ouvrage}
                  onChange={(e) => setNom_maitre_ouvrage(e.target.value)}
                ></TextField2T>{" "}
                <TextField2T
                  label="Prénom du maître d'ouvrage"
                  mandatory={true}
                  value={first_name_maitre_ouvrage}
                  onChange={(e) => setFirst_name_maitre_ouvrage(e.target.value)}
                ></TextField2T>
                <TextField2T
                  label="Adresse email du maître d'ouvrage"
                  mandatory={true}
                  value={email_maitre_ouvrage}
                  onChange={(e) => setEmail_maitre_ouvrage(e.target.value)}
                  type={"email"}
                ></TextField2T>
                <TextField2T
                  label="Téléphone personnel du maître d'ouvrage"
                  mandatory={true}
                  value={telephone_maitre_ouvrage}
                  onChange={(e) => setTelephone_maitre_ouvrage(e.target.value)}
                  type="phone"
                ></TextField2T>
                {audit_config && hasAudit(orgData) && (
                  <>
                    <DropDownGPT03
                      force_down={true}
                      items={audit_profil_options}
                      className="w-full"
                      label="Profil particulier"
                      value={audit_config.profil}
                      onChange={(e) =>
                        setAuditConfig({
                          ...audit_config,
                          profil: e.value,
                        })
                      }
                    ></DropDownGPT03>
                    <DropDownGPT03
                      items={audit_mpr_options}
                      className="w-full"
                      force_down={true}
                      label="Catégorie MPR"
                      value={audit_config.mpr}
                      onChange={(e) =>
                        setAuditConfig({
                          ...audit_config,
                          mpr: e.value,
                        })
                      }
                    ></DropDownGPT03>
                    <TextField2T
                      label="Nombre de personnes dans le foyer fiscal"
                      value={audit_config.foyer_fiscal || ""}
                      mandatory={false}
                      onChange={(e) =>
                        setAuditConfig({
                          ...audit_config,
                          foyer_fiscal: e.target.value,
                        })
                      }
                      transparent={false}
                    ></TextField2T>
                  </>
                )}
              </div>

              <div className="text-h1 font-semibold mt-6">
                {" "}
                Fichiers déposés
              </div>
              <Space y={5} />
              {invoiceData?.plans_files?.map((file, index) => (
                <div key={index} className="flex w-full">
                  <div className="flex flex-row items-center gap-2">
                    <div className="text-h3 font-medium w-c100">
                      {"Fichier " + (index + 1)}
                    </div>
                    <SecondaryButton
                      className={"w-fit"}
                      onClick={() => handleViewFile(file)}
                    >
                      Ouvrir
                    </SecondaryButton>
                    <div className="text-h3 rounded-md py-1 h-fit min-h-7 px-2 mr-2  flex-grow   font-light text-pr bg-shadow_4">
                      {limitStringSize(file.name)}
                    </div>
                  </div>
                </div>
              ))}

              <Space y={10} />
              <div className="text-h1 font-semibold">
                Ajouter de nouveaux fichiers
              </div>
              <Space y={5} />
              <Dropzone2
                onDrop={async (files) => {
                  setLoadingDrop(true);
                  const token = await getOrRefreshFirebaseToken();

                  let new_drop_files = [];
                  for (let i = 0; i < files.length; i++) {
                    let res = await uploadDropZoneTemporary(
                      token,
                      files[i],
                      files[i]?.name,
                      prefix
                    );
                    new_drop_files.push({ url: res.url, name: res?.name });
                  }

                  setDroppedFiles([...dropped_files, ...new_drop_files]);
                  setDroppedExists(true);
                  setLoadingDrop(false);
                }}
                files={dropped_files}
                onDelete={onDelete}
                loading={loading_drop}
              />
            </div>
          </div>
          <div className="flex flex-col max-w-c600  w-full h-fit mr-4    ">
            <div className="text-h1 font-semibold">Panier</div>

            <div className="flex flex-col w-c600 mt-2">
              <DropDownGPTS3
                items={all_articles.map((article) => {
                  return { value: article.id, label: article.name };
                })}
                label={"Ajouter un article"}
                onChange={(e) => {
                  const selected_article = all_articles.find(
                    (article) => article.id === e.value
                  );
                  if (selected_article) {
                    let new_selected_articles = {
                      ...selected_article,
                      price: getArticlePrice(selected_article),
                      supplement_total: 0,
                      quantity: nombre_maisons || 1,
                      tax: 20,
                      total:
                        getArticlePrice(selected_article) *
                          1.2 *
                          nombre_maisons || 1,
                    };
                    setSelected_articles((prev) => [
                      ...prev,
                      new_selected_articles,
                    ]);
                  }
                  force_articles_updated.current = true;
                }}
              ></DropDownGPTS3>

              <div className="flex flex-col gap-3  mt-3 ">
                {selected_articles.map((a, index) => (
                  <div
                    key={index}
                    className="flex flex-col gap-2 border-l-2 rounded-lg border-blue-200 bg-blue-50 p-2"
                  >
                    <div className="flex flex-row gap-2">
                      <DropDownGPT03
                        items={all_articles.map((article) => {
                          return { value: article.id, label: article.name };
                        })}
                        value={selected_articles[index].id}
                        className={"flex-grow"}
                        label={"Choisir un article"}
                        onChange={(e) => {
                          const selected_article = all_articles.find(
                            (article) => article.id === e.value
                          );
                          if (selected_article) {
                            setSelected_articles(
                              selected_articles.map((article, i) => {
                                if (i === index) {
                                  return {
                                    ...selected_article,
                                    price: getArticlePrice(selected_article),
                                    supplement_total: 0,
                                    quantity: nombre_maisons || 1,
                                    tax: 20,
                                    total:
                                      selected_article.base_price *
                                        1.2 *
                                        nombre_maisons || 1,
                                  };
                                }
                                return article;
                              })
                            );
                          }
                          force_articles_updated.current = true;
                        }}
                      ></DropDownGPT03>
                      <SecondaryButton
                        onClick={() => {
                          setSelected_articles(
                            selected_articles.filter(
                              (article, i) => i !== index
                            )
                          );
                        }}
                        className={"w-fit h-fit"}
                      >
                        Supprimer
                      </SecondaryButton>
                    </div>
                    <div className="flex flex-row gap-3 items-center text-h3 text-shadow_50">
                      Prix
                      <CurrencyField
                        transparent={false}
                        disabled={false}
                        value={selected_articles[index].price}
                        label={"Prix"}
                        className="w-20"
                        onChangeFloat={(e) => {
                          const new_price = parseFloat(e);
                          setSelected_articles(
                            selected_articles.map((article, i) => {
                              if (i === index) {
                                return {
                                  ...article,
                                  price: new_price,
                                };
                              }
                              return article;
                            })
                          );
                          force_articles_updated.current = true;
                        }}
                      ></CurrencyField>
                      Qté
                      <TextField2
                        transparent={false}
                        value={selected_articles[index].quantity}
                        label={"Quantité"}
                        className="max-w-16"
                        type="number"
                        onChange={(e) => {
                          const new_quantity = parseFloat(e.target.value);
                          setSelected_articles(
                            selected_articles.map((article, i) => {
                              if (i === index) {
                                return {
                                  ...article,
                                  quantity: new_quantity,
                                };
                              }
                              return article;
                            })
                          );
                          force_articles_updated.current = true;
                        }}
                      ></TextField2>
                      TVA
                      <DropDownGPT0
                        disabled={true}
                        items={tva_items}
                        value={tva_items.find(
                          (item) => item.value === selected_articles[index].tax
                        )}
                        onChange={(e) => {
                          const new_tax = e.value;
                          setSelected_articles(
                            selected_articles.map((article, i) => {
                              if (i === index) {
                                return {
                                  ...article,
                                  tax: new_tax,
                                };
                              }
                              return article;
                            })
                          );
                          force_articles_updated.current = true;
                        }}
                        label={"TVA"}
                        className={"min-w-c100"}
                      ></DropDownGPT0>
                    </div>{" "}
                    <div className="flex flex-row gap-2 items-center">
                      {selected_articles[index].discount ? (
                        <>
                          <SecondaryButton
                            className={"w-fit"}
                            onClick={() =>
                              // set discount to {type : "percent", value : 10}
                              {
                                setSelected_articles(
                                  selected_articles.map((article, i) => {
                                    if (i === index) {
                                      return {
                                        ...article,
                                        discount: undefined,
                                      };
                                    }
                                    return article;
                                  })
                                );
                                force_articles_updated.current = true;
                              }
                            }
                          >
                            Supprimer remise
                          </SecondaryButton>
                          <DropDownGPT0X
                            items={[
                              { value: "percent", label: "%" },
                              { value: "amount", label: "Valeur" },
                            ]}
                            value={selected_articles[index].discount?.type}
                            onChange={(e) => {
                              setSelected_articles(
                                selected_articles.map((article, i) => {
                                  if (i === index) {
                                    return {
                                      ...article,
                                      discount: {
                                        type: e.value,
                                        value: 10, // Default value for percent
                                      },
                                    };
                                  }
                                  return article;
                                })
                              );
                              force_articles_updated.current = true;
                            }}
                            label={"Type de remise"}
                            className={"min-w-32"}
                          ></DropDownGPT0X>
                        </>
                      ) : (
                        <SecondaryButton
                          className={"w-fit"}
                          onClick={() =>
                            // set discount to {type : "percent", value : 10}
                            {
                              setSelected_articles(
                                selected_articles.map((article, i) => {
                                  if (i === index) {
                                    return {
                                      ...article,
                                      discount: {
                                        type: "percent",
                                        value: 10,
                                      },
                                    };
                                  }
                                  return article;
                                })
                              );
                              force_articles_updated.current = true;
                            }
                          }
                        >
                          Ajouter remise
                        </SecondaryButton>
                      )}

                      {selected_articles[index].discount?.type ===
                        "percent" && (
                        <>
                          <DropDownGPT0X
                            items={remises_items}
                            value={selected_articles[index].discount?.value}
                            onChange={(e) => {
                              setSelected_articles(
                                selected_articles.map((article, i) => {
                                  if (i === index) {
                                    return {
                                      ...article,
                                      discount: {
                                        type: "percent",
                                        value: e.value,
                                      },
                                    };
                                  }
                                  return article;
                                })
                              );
                              force_articles_updated.current = true;
                            }}
                            label={"Valeur de remise"}
                            className={"min-w-32"}
                          ></DropDownGPT0X>
                          <CurrencyField
                            value={
                              (selected_articles[index].discount?.value *
                                selected_articles[index].price *
                                selected_articles[index].quantity) /
                              100
                            }
                            label={"Montant de remise"}
                            disabled={true}
                            className="max-w-32"
                          ></CurrencyField>
                        </>
                      )}
                      {selected_articles[index].discount?.type === "amount" && (
                        <>
                          <CurrencyField
                            transparent={false}
                            value={selected_articles[index].discount?.value}
                            onChangeFloat={(e) => {
                              setSelected_articles(
                                selected_articles.map((article, i) => {
                                  if (i === index) {
                                    return {
                                      ...article,
                                      discount: {
                                        type: "amount",
                                        value: parseFloat(e),
                                      },
                                    };
                                  }
                                  return article;
                                })
                              );
                              force_articles_updated.current = true;
                            }}
                            label={"Montant de remise"}
                            disabled={false}
                            className="max-w-32"
                          ></CurrencyField>
                        </>
                      )}
                    </div>{" "}
                    <div className="flex flex-row gap-3 items-center text-h3 text-shadow_50">
                      HT
                      <CurrencyField
                        value={
                          Math.round(selected_articles[index].total_ht * 100) /
                          100
                        }
                        label={"Total"}
                        disabled={true}
                        className="w-16"
                      ></CurrencyField>
                      <div className="w-fit min-w-fit">APR REM</div>
                      <CurrencyField
                        value={
                          Math.round(
                            selected_articles[index].total_ht_rem * 100
                          ) / 100
                        }
                        label={"Total"}
                        disabled={true}
                        className="w-16"
                      ></CurrencyField>
                      TTC
                      <CurrencyField
                        value={
                          Math.round(selected_articles[index].total_ttc * 100) /
                          100
                        }
                        label={"Total"}
                        disabled={true}
                        className="w-16"
                      ></CurrencyField>
                    </div>{" "}
                    <div className="flex flex-col gap-2 ">
                      <MLTFGPT1
                        transparent={false}
                        label={"Description de l'article"}
                        rows={3}
                        value={selected_articles[index].description}
                        onChange={(e) => {
                          setSelected_articles(
                            selected_articles.map((article, i) => {
                              if (i === index) {
                                return {
                                  ...article,
                                  description: e.target.value,
                                };
                              }
                              return article;
                            })
                          );
                        }}
                        canResize={true}
                      ></MLTFGPT1>
                      <MLTFGPT1
                        transparent={false}
                        label={"Conditions de règlement"}
                        rows={3}
                        value={selected_articles[index].conditions_reglement}
                        onChange={(e) => {
                          setSelected_articles(
                            selected_articles.map((article, i) => {
                              if (i === index) {
                                return {
                                  ...article,
                                  conditions_reglement: e.target.value,
                                };
                              }
                              return article;
                            })
                          );
                        }}
                        canResize={true}
                      ></MLTFGPT1>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <Space y={20} />
            <div className="flex flex-col gap-2 w-full">
              {article_configuration.type === "house" && (
                <div className="flex flex-col gap-1">
                  <div className="text-h1 font-semibold">
                    Informations maison
                  </div>
                  <Space y={5} />
                  <InputNumber
                    addonAfter="maisons"
                    value={nombre_maisons}
                    min={1}
                    defaultValue={3}
                    onChange={(value) => setNombre_maisons(value)}
                  />
                  <Space y={5} />
                  <div className="text-h3 text-shadow_50">Surface par maison</div>
                  <div className="flex flex-col gap-2">
                    {surfaces.map((s, i) => (
                      <div key={i} className="flex flex-row items-center gap-2">
                        <div className="text-h4 text-shadow_50 min-w-[80px]">Maison {i + 1}</div>
                        <InputNumber
                          value={s}
                          addonAfter="m2"
                          min={0}
                          defaultValue={0}
                          onChange={(value) => {
                            const newSurfaces = [...surfaces];
                            newSurfaces[i] = value || 0;
                            setSurfaces(newSurfaces);
                            setSurface(newSurfaces.reduce((a, b) => a + (b || 0), 0));
                          }}
                          status={s === 0 ? "error" : "success"}
                        />
                      </div>
                    ))}
                  </div>
                  <div className="text-h4 text-shadow_50 mt-1">
                    Surface totale : {surfaces.reduce((a, b) => a + (b || 0), 0)} m2
                  </div>
                </div>
              )}
              {["extension", "tertiaire", "renovation"].includes(article_configuration.type) && (
                <div className="flex flex-col gap-1">
                  <div className="text-h1 font-semibold">
                    Surface
                  </div>
                  <Space y={5} />
                  <InputNumber
                    addonAfter="m2"
                    value={surfaces[0] || 0}
                    min={0}
                    defaultValue={0}
                    onChange={(value) => {
                      const val = value || 0;
                      setSurfaces([val]);
                      setSurface(val);
                    }}
                  />
                </div>
              )}

            </div>

            {/* Détails suppléments */}
            {selected_articles.some((a) => checkArticleSupplementSurface(a) !== 0) && (
              <div className="flex flex-col gap-1 p-2 bg-blue-50 border-1 border-blue-200 rounded-md">
                <div className="text-h4 font-medium text-shadow_50">Détails suppléments</div>
                {selected_articles
                  .filter((a) => checkArticleSupplementSurface(a) !== 0)
                  .map((article, index) => {
                    const breakdown = getArticleSupplementBreakdown(article);
                    return (
                      <div key={index} className="flex flex-col gap-0.5">
                        <div className="text-h5 text-shadow_50 flex flex-row justify-between">
                          <div className="font-medium">{article.name}</div>
                          <div>+ {formatToEuro(checkArticleSupplementSurface(article))}</div>
                        </div>
                        {surfaces.length > 1 && breakdown.map((b) => (
                          <div key={b.index} className="text-h5 text-shadow_25 ml-4 flex flex-row justify-between">
                            <div>Maison {b.index + 1} ({b.surface} m²)</div>
                            <div>{b.supplement !== 0 ? `+ ${formatToEuro(b.supplement)}` : "aucun"}</div>
                          </div>
                        ))}
                      </div>
                    );
                  })}
              </div>
            )}

            {handleSurfaceTranches() !== 0 && (
              <div className="flex flex-col gap-1 p-2 bg-blue-50 border-1 border-blue-200 rounded-md">
                <div className="text-h4 font-medium text-shadow_50">Tranches de surface</div>
                {getSurfaceTranchesBreakdown().map((b) => (
                  <div key={b.index} className="text-h5 text-shadow_25 ml-4 flex flex-row justify-between">
                    <div>Maison {b.index + 1} ({b.surface} m²)</div>
                    <div>{b.addition !== 0 ? `+ ${formatToEuro(b.addition)}` : "aucun"}</div>
                  </div>
                ))}
              </div>
            )}

            {/* Détails remises */}
            {getTotals().total_remise > 0 && (
              <div className="flex flex-col gap-1 p-2 bg-green-50 border-1 border-green-200 rounded-md">
                <div className="text-h4 font-medium text-green-700">Détails remises</div>
                {selected_articles
                  .filter((a) => a.discount && getDiscountValue(a) > 0)
                  .map((article, index) => (
                    <div key={index} className="text-h5 text-green-600 flex flex-row justify-between">
                      <div>
                        {article.name}
                        {article.discount?.type === "percent" ? ` (${article.discount.value}%)` : ""}
                      </div>
                      <div>- {formatToEuro(getDiscountValue(article))}</div>
                    </div>
                  ))}
              </div>
            )}

            {/* Total */}
            <Space y={10} />
            <div className="text-h1 font-semibold">Total</div>
            <Divider orientation="horizontal" />
            <Space y={5} />
            <div className="flex flex-row justify-between w-full text-h3 text-shadow_50">
              <div className="text-h3">Base HT</div>
              <div className="text-h3">{formatToEuro(getTotals().base_ht)}</div>
            </div>
            {getTotals().supplement > 0 && (
              <div className="flex flex-row justify-between w-full text-blue-600">
                <div className="text-h3">Supplément</div>
                <div className="text-h3">+ {formatToEuro(getTotals().supplement)}</div>
              </div>
            )}
            {getTotals().total_remise > 0 && (
              <div className="flex flex-row justify-between w-full text-green-600">
                <div className="text-h3">Remises</div>
                <div className="text-h3">- {formatToEuro(getTotals().total_remise)}</div>
              </div>
            )}
            <div className="flex flex-row justify-between w-full mt-2">
              <div className="text-h3">Total HT</div>
              <div className="text-h3">{formatToEuro(getTotals().total_ht)}</div>
            </div>
            <div className="flex flex-row justify-between w-full text-shadow_50 mb-2">
              <div className="text-h3">TVA 20%</div>
              <div className="text-h3">{formatToEuro(getTotals().tva)}</div>
            </div>
            <Divider orientation="horizontal" />
            <div className="flex flex-row justify-between w-full mt-1">
              <div className="text-h3 font-semibold">Total TTC</div>
              <div className="text-h3 font-semibold">{formatToEuro(getTotals().total_ttc)}</div>
            </div>
            <Space y={20} />
            <MLTFGPT1
              label={"Informations complémentaires"}
              value={complementary_infos}
              rows={4}
              canResize={true}
              onChange={(e) => setComplementaryInfos(e.target.value)}
            ></MLTFGPT1>
            <Space y={20} />

            <PrimaryButton
              mobile={mobile}
              className="w-fit"
              big={true}
              disabled={selected_articles.length === 0}
              onClick={() => createInvoice()}
            >
              {isModifying ? "Modifier le devis" : "Générer le devis"}{" "}
              <SmallSpinner margin={2} loading={loadingData} />
            </PrimaryButton>
          </div>
        </div>{" "}
      </div>
    </div>
  );
}

export default NewInvoiceFromDraft;

export function formatToEuro(amount) {
  // Convert the float to a string with two decimal places and replace '.' with ','
  if (typeof amount === "string") {
    amount = amount.replace(".", ",");
    amount = parseFloat(amount);
  }
  const formattedAmount = amount.toLocaleString("fr-FR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `${formattedAmount}€`;
}

export const tva_items = [
  {
    value: 0.9,
    label: "0.9%",
  },
  {
    value: 1.05,
    label: "1.05%",
  },
  {
    value: 1.75,
    label: "1.75%",
  },

  {
    value: 2.1,
    label: "2.1%",
  },
  {
    value: 4,
    label: "4.0%",
  },
  {
    value: 5.5,
    label: "5.5%",
  },
  {
    value: 6,
    label: "6.0%",
  },
  {
    value: 6.5,
    label: "6.5%",
  },
  {
    value: 8.5,
    label: "8.5%",
  },
  {
    value: 9.2,
    label: "9.2%",
  },
  {
    value: 10,
    label: "10.0%",
  },
  {
    value: 13,
    label: "13.0%",
  },
  {
    value: 15.385,
    label: "15.385%",
  },
  {
    value: 19.6,
    label: "19.6%",
  },
  {
    value: 20,
    label: "20.0%",
  },
];

export const remises_items = [
  { value: 5, label: "5%" },
  { value: 10, label: "10%" },
  { value: 15, label: "15%" },
  { value: 20, label: "20%" },
  { value: 25, label: "25%" },
  { value: 30, label: "30%" },
  { value: 40, label: "40%" },
  { value: 50, label: "50%" },
  { value: 60, label: "60%" },
  { value: 70, label: "70%" },
  { value: 80, label: "80%" },
];
